import React, {useEffect, useState, useRef} from "react";
import axios from "axios";
import $ from "jquery";
import DataTable from "datatables.net";
import {Link} from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import {useHistory} from 'react-router';
import {toAbsoluteUrl} from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import alertify from "alertifyjs";
import {date_format, datetime_format} from "../Common/DateFormat";

import {API_URL} from '../constants.js';

import {
    Card,
    CardBody,
    CardHeader,
    CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {useTranslation} from "react-i18next";

export function CollectionCenterList(props) {
    const { t } = useTranslation();
    const [collectionCenters, setCollectionCenters] = useState([]);
    const [collectionCenter, setCollectionCenter] = useState(-1);
    const [show, setShow] = useState(false);
    const history = useHistory();
    const [disabled, setDisabled] = useState(0);
    const [iconDisabled, setIconDisabled] = useState(1);

    const setCurrentCollectionCenter = (collectionCenter) => {
        setCollectionCenter(collectionCenter);
        setShow(true);

    };

    const handleClose = () => setShow(false);

    const deleteCollectionCenter = () => {
        setDisabled(1);
        setIconDisabled(0);
        axios.post(
            API_URL + 'collection-center/' + collectionCenter.id + '/delete'
        ).then((response) => {
            if (response.data.status) {
                history.go(0);
                setShow(false);
                alertify.success(response.data.message);
            } else {
                setDisabled(0);
                setIconDisabled(1);
                alertify.error(response.data.message);
                return null;
            }
        }).catch((error) => {
            setDisabled(0);
            setIconDisabled(1);
            alertify.error("Something went wrong. Try again!");
        });
    }

    useEffect(() => {

        axios.get(API_URL + 'collection-center').then((response) => {
            if (response.data.status) {

                setCollectionCenters(response.data.data);

                $("#collection_center_table").DataTable();
            } else {
                alertify.error(response.data.message);
                return null;
            }
        }).catch((error) => {
            alertify.error("Something went wrong. Try again!");
        });

    }, []);


    return (
        <>
            <Row>
                <Col md={12}>
                    <Card>
                        <CardHeader title={t("Add New Collection Center")}>
                            <CardHeaderToolbar>
                                <Link to="/collection-center/create" className="btn btn-primary btn-sm mx-3">
                                    {t("Create Collection Center")}
                                </Link>
                            </CardHeaderToolbar>
                        </CardHeader>
                        <CardBody style={{overflow:'auto'}}>

                            <table id="collection_center_table" className="stratprop_datatable table table-bordered table-striped">
                                <thead>
                                <tr>
                                    <th>{t("SN.")}</th>
                                    <th>{t("Name")}</th>
                                    <th>{t("Phone NO 1")}</th>
                                    <th>{t("Phone No 2")}</th>
                                    <th>{t("Address")}</th>
                                    <th>{t("Latitude")}</th>
                                    <th>{t("Longitude")}</th>
                                    <th>{t("Lab")}</th>
                                    <th>{t("Actions")}</th>
                                </tr>
                                </thead>
                                <tbody>
                                {collectionCenters.length > 0 ? (
                                    collectionCenters.map((collectionCenter, index) => (
                                        <tr key={collectionCenter.id}>
                                            <td>{index + 1}</td>
                                            <td>{collectionCenter.name}</td>
                                            <td>{collectionCenter.phone_no1}</td>
                                            <td>{collectionCenter.phone_no2}</td>
                                            <td>{collectionCenter.address}</td>
                                            <td>{collectionCenter.latitude}</td>
                                            <td>{collectionCenter.longitude}</td>
                                            <td>{collectionCenter.lab.name}</td>
                                            <td>
                                                <Link to={`/collection-center/edit/${collectionCenter.id}`}
                                                      className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3">
                                                    <span className="svg-icon svg-icon-md svg-icon-primary">
                                                          <SVG
                                                              src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
                                                          />
                                                    </span>
                                                </Link>
                                                <a
                                                    onClick={() => setCurrentCollectionCenter(collectionCenter)}
                                                    key={collectionCenter.id}
                                                    className="btn btn-icon btn-light btn-hover-danger btn-sm">
                                                    <span className="svg-icon svg-icon-md svg-icon-danger">
                                                      <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")}/>
                                                    </span>
                                                </a>

                                            </td>

                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={9}>{t("No Collection Center")}</td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{t("Delete Collection Center")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{t("Are you sure you want to Delete?")}</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        {t("Close")}
                    </Button>
                    <Button variant="primary" onClick={deleteCollectionCenter} disabled={disabled}>
                        {t("Confirm")}
                        <span
                            dangerouslySetInnerHTML={{__html: disabled ? `<i class='fas fa-spinner fa-spin'></i>` : ``}}/>
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}